const FinanceIndex = () => import('@/views/Dashboard/Finance/FinanceIndex');
const Sales = () => import('@/views/Dashboard/Finance/Sales/Sales');
const Payments = () => import('@/views/Dashboard/Finance/Payments/Payments');
const Expenses = () => import('@/views/Dashboard/Finance/Expenses/Expenses');
const Inventory = () => import('@/views/Dashboard/Finance/Inventory');
const CashboxesManagement = () => import('@/views/Dashboard/Finance/CashboxesManagement');
const WithdrawConfimationForm = () => import('@/components/Finance/CashboxesManagement/WithdrawConfimationForm');

export default {
  path: '/finance',
  component: FinanceIndex,
  children: [
    {
      path: 'sales',
      name: 'sales',
      component: Sales,
      meta: {
        preserveTableState: true,
        resetPageStateOnLeave: true,
        pageFilterStorageKeys: ['salesTypeFilter'],
      },
    },
    {
      path: 'sales/preselected/:memberPreSelectedId',
      name: 'salesPreSelected',
      component: Sales,
    },
    {
      path: 'payments',
      name: 'payments',
      component: Payments,
      meta: {
        preserveTableState: true,
        resetPageStateOnLeave: true,
        pageFilterStorageKeys: [
          'paymentDateFromFilter',
          'paymentDateToFilter',
          'paymentMethodFilter',
          'paymentTypeFilter',
        ],
      },
    },
    {
      path: 'payments/preselected/:memberPreSelectedId',
      name: 'paymentsPreSelected',
      component: Payments,
    },
    {
      path: 'expenses',
      name: 'expenses',
      component: Expenses,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'inventory',
      name: 'inventory',
      component: Inventory,
      meta: { preserveTableState: true },
    },
    {
      path: 'cashboxes-management',
      name: 'cashboxes-management',
      component: CashboxesManagement,
      meta: { preserveTableState: true, resetPageStateOnLeave: true },
    },
    {
      path: 'withdraw-confirmation',
      name: 'withdraw-confirmation',
      component: WithdrawConfimationForm,
      meta: { preservePageStateFor: 'cashboxes-management' },
    },
  ],
};
